import { baseApi } from './baseApi';
import { withDefinedFields, toFormData } from './apiUtils';

export const requestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getManagerRequests: builder.query({
      query: (status) => ({
        url: '/manager/requests',
        params: withDefinedFields([['status', status]]),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((r) => ({ type: 'Request', id: r.id })),
              { type: 'Request', id: 'LIST' },
            ]
          : [{ type: 'Request', id: 'LIST' }],
    }),
    getManagerRequest: builder.query({
      query: (id) => `/manager/requests/${id}`,
      providesTags: (result, error, id) => [{ type: 'Request', id }],
    }),
    requestGroupCreate: builder.mutation({
      query: (payload) => ({
        url: '/manager/requests/group-create',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'Request', id: 'LIST' }],
    }),
    requestGroupUpdate: builder.mutation({
      query: ({ groupId, tileFile, ...payload }) => {
        const url = `/manager/requests/group-update/${groupId}`;
        if (tileFile) {
          return {
            url,
            method: 'POST',
            body: toFormData([
              ['name', payload.name],
              ['tile', tileFile],
              ['terms', payload.terms],
              ['geolocation_required', payload.geolocation_required],
              ['broadcast', payload.broadcast],
              ...(payload.channels ?? []).map((c) => ['channels', c]),
            ]),
          };
        }
        return { url, method: 'POST', body: payload };
      },
      invalidatesTags: [{ type: 'Request', id: 'LIST' }],
    }),
    requestGroupEnable: builder.mutation({
      query: ({ groupId, enabled }) => ({
        url: `/manager/requests/group-enable/${groupId}`,
        method: 'POST',
        body: { enabled },
      }),
      invalidatesTags: [{ type: 'Request', id: 'LIST' }],
    }),

    getAdminRequests: builder.query({
      query: (status) => ({
        url: '/admin/requests',
        params: withDefinedFields([['status', status]]),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((r) => ({ type: 'Request', id: r.id })),
              { type: 'Request', id: 'ADMIN-LIST' },
            ]
          : [{ type: 'Request', id: 'ADMIN-LIST' }],
    }),
    getAdminRequest: builder.query({
      query: (id) => `/admin/requests/${id}`,
      providesTags: (result, error, id) => [{ type: 'Request', id }],
    }),
    approveRequest: builder.mutation({
      query: ({ id, note }) => ({
        url: `/admin/requests/${id}/approve`,
        method: 'POST',
        body: withDefinedFields([['note', note]]),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Request', id },
        { type: 'Request', id: 'ADMIN-LIST' },
        { type: 'Group', id: 'LIST' },
      ],
    }),
    rejectRequest: builder.mutation({
      query: ({ id, note }) => ({
        url: `/admin/requests/${id}/reject`,
        method: 'POST',
        body: withDefinedFields([['note', note]]),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Request', id },
        { type: 'Request', id: 'ADMIN-LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetManagerRequestsQuery,
  useGetManagerRequestQuery,
  useRequestGroupCreateMutation,
  useRequestGroupUpdateMutation,
  useRequestGroupEnableMutation,
  useGetAdminRequestsQuery,
  useGetAdminRequestQuery,
  useApproveRequestMutation,
  useRejectRequestMutation,
} = requestApi;
